export default "__VITE_ASSET__BxfJlUc4__"